import React from 'react';
import { NavLink } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const SidebarMenuListItem = ({ navItem, disabled = true, isActiveLink = true }) => {
  const classes = useStyles();

  return (
    <ListItem style={{ padding: '2px 0 1px' }} disableGutters>
      <Button
        className={clsx(classes.navButton, { [classes.activateBtn]: isActiveLink })}
        component={NavLink}
        disabled={disabled}
        to={navItem.path}>
        <span className={classes.iconWrapper}>{<navItem.icon />}</span>
        {navItem.label}
      </Button>
    </ListItem>
  );
};

export default SidebarMenuListItem;

const useStyles = makeStyles(theme => ({
  navButton: {
    padding: '4px 14px',
    justifyContent: 'flex-start',
    width: '100%',
    fontWeight: 500,
    borderRadius: 0,
    '&:hover': { color: theme.palette.primary.main },
  },
  activateBtn: {
    '&.active': { color: theme.palette.primary.main },
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24, // Standard width for all icons
    height: 24, // Standard height for all icons
    marginRight: 16, // Consistent margin
  },
}));
